/* 
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

/**
 * Contient les textes utilisés dans le logiciel en langue espagnole.
 * @type type
 */
const texte_es  = {
  step:"paso",
  var1:"Nuevo valor para la variable ",
  var2:"Entre un valor comprendido entre ",
  et:" y ",
  incorrect:"Entrada incorrecta",
  //Chaînes servant suivant la langue à reconstruire les formules mathématiques
  abs:"abs",
  intgr:"int",
  sqrt:"sqrt",
  rac:"rac",
  sin:"sen",
  cos:"cos",
  tan:"tan",
  ln:"ln",
  exp:"exp",
  arctan:"arctan",
  arccos:"arccos",
  arcsin:"arcsen",
  ch:"cosh",
  sh:"senh",
  th:"tanh",
  argch:"argcosh",
  argsh:"argsenh",
  argth:"argtanh",
  rand:"rand",
  conj:"conj",
  arg:"arg",
  re:"re",
  im:"im",

  maxi:"máx",
  mini:"mín",
  gcd:"mcd",
  lcm:"mcm",
  ncr:"nCr",
  npr:"nPr",
  mod:"mod",
  si:"si",
  integrale:"integral",
  fact:"fact",
  somme:"suma",
  produit:"producto",
  left:"izquierda",
  right:"derecha"
};

module.exports = texte_es



// WEBPACK FOOTER //
// ./src/textes/textes_es.js